export default docs =>
  docs
    .map(p => p.updatedAt)
    .filter(updatedAt => updatedAt !== undefined)
    .reduce((max, cur) => Math.max(max, cur), -Infinity)



// WEBPACK FOOTER //
// ./src/sagas/setupProjectsSaga/mostRecentUpdatedAt.js